<div class="main-div">
    <div fxLayout="column" fxLayoutGap="10px" class="center-div">
        <div class="banner-div" fxLayout="row">

            <a [href]="bannerUrl">
                <img class="banner" [src]="bannerImage" alt="Banner Image" loading="lazy" width="100%" height="500">
            </a>
            <button *ngIf="!userLoggedIn" class="top-btn"
            appTrackClick 
            [buttonProps]="{
            title: 'about_top_join_free_button',
            feature_context: 'ABOUT_CREATICS'
            }"
            ><a style="color: white; text-decoration: none;" [href]="bannerUrl">{{bannerButton}}</a></button>

        </div>


        <div class="heading-div" fxLayout="row wrap" fxLayoutAlign="center">

            <h1 *ngIf="mainUrl==false">{{aboutpage.mainHeading}}</h1>

            <a style="color: black; padding: 10px;" *ngIf="mainUrl==true" href="{{aboutpage.mainUrl}}">{{aboutpage?.mainHeading}}</a>

        </div>

        <div class="videoInfo" fxLayout="row wrap" fxLayoutAlign="center" fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="center center">

            <div class="video-div" fxLayout="row">

                <video class="video" [src]="videoUrl" controls="true" disablePictureInPicture preload="metadata" controls
                [poster]="posterImage" controlsList="nodownload noplaybackrate"  id="videoBG" height="100%" width="100%"
                type="video/mp4" (ended)="loadVideo()" 
                (play)="onPlay()">
            </video>
                
            </div>

            <div class="info-div" fxLayout="row">

                <div class="content" fxLayout="column" fxLayoutAlign="start center">

                    <p class="desc-scroll">{{description}}</p>

                </div>
            </div>

        </div>
        <div fxLayout="row wrap" fxLayoutAlign="center">

            <div class="content-div" fxLayoutGap="15px" fxLayout="row" fxLayout.lt-md="column">

                <div *ngFor="let item of aboutpage?.creaticsContents" fxFlex="33%">

                    <div fxLayout="column" class="row-div">
                        <div class="img-div">
                            <img fxFlex="100%" [src]="getFileNameFromUrl(item?.image)" alt=" item image" loading="lazy" width="300" height="250">
                        </div>
                        <p [innerHTML]=item.description></p>
                    </div>

                </div>

            </div>

        </div>


        <div class="event-main-div" fxLayout="row wrap">
            <div class="width-class" fxLayout="row" fxLayout.lt-md="row wrap" fxLayoutGap="2px">
                <img fxFlex="50%" fxFlex.lt-md="100%" [src]="fanCreatorImg1" alt="table image" width="400" height="350">
                <img fxFlex="50%" fxFlex.lt-md="100%" [src]="fanCreatorImg2" alt="table img" width="400" height="350">
            </div>
   
        </div>

        <div class="heading2" fxLayout="row wrap" fxLayoutAlign="center">

            <p>{{creaticsSubject}}</p>

        </div>

        <div *ngFor="let item of aboutpage?.buttons" class="heading2 btn-div" fxLayout="row" fxLayoutAlign="center"
        [ngStyle]="userLoggedIn ? { 'display': 'none'} : {}">

            <a href="{{item?.buttonUrl}}"  *ngIf="!userLoggedIn">
                <button class="btn"
                 appTrackClick 
                [buttonProps]="{
                title: 'about_middle_join_free_button',
                feature_context: 'ABOUT_CREATICS'
                }"
                >
                    {{item?.buttonName}}
                </button>
            </a>

        </div>


        <!-- creatics features list web-vew -->

        <div class="event-main-div" fxLayout="row wrap" fxHide.lt-md>
            <div class="width-class" fxLayout="column" fxLayoutGap="15px">
                <div class="title">
                    <h2>{{eventMainHeading}}</h2>
                </div>
                <div class="about-div event-div" *ngFor="let event of aboutpage?.creaticsLists" fxHide.lt-md
                    [ngStyle]="event.sequence%2==0?{'background-color':'#4FC4D5'}:{'background': 'linear-gradient(#f14925 100%, #FA4616 0%)'}">
                    <div *ngIf="event.sequence%2!=0" fxLayout="row">
                        <a href="{{event?.url}}"
                         appTrackClick 
                        [buttonProps]="{
                        title: 'about_'+event?.title+'_button',
                        feature_context: 'ABOUT_CREATICS'
                        }"
                                >
                            <div class="event-image-div" fxLayout="row">
                                <img class="event-image" [src]="getFileNameFromUrl(event?.image)" alt="aboutpage Image" loading="lazy" width="300" height="250">
                            </div>
                        </a>
                        <div class="event-details-div" fxLayout="row wrap" fxLayoutAlign="start center">
                            <p class="event-heading"><a href="{{event?.url}}"
                                appTrackClick 
                                [buttonProps]="{
                                title: 'about_'+event?.title+'_button',
                                feature_context: 'ABOUT_CREATICS'
                                }"
                                >
                                    {{event?.title}}</a>
                            </p>
                            <p class="event-details">{{event?.text}}</p>
                        </div>
                        <hr>
                    </div>

                    <div *ngIf="event.sequence%2==0" fxLayout="row">

                        <div class="event-details-div" fxLayout="row wrap" fxLayoutAlign="start center">
                            <p class="event-heading"><a href="{{event.url}}"
                                 appTrackClick 
                                [buttonProps]="{
                                title: 'about_'+event?.title+'_button',
                                feature_context: 'ABOUT_CREATICS'
                                }"
                                >
                                    {{event?.title}}</a>
                            </p>
                            <p class="event-details">{{event?.text}}</p>
                        </div>

                        <a href="{{event?.url}}"
                         appTrackClick 
                        [buttonProps]="{
                        title: 'about_'+event?.title+'_button',
                        feature_context: 'ABOUT_CREATICS'
                        }"
                        >
                            <div class="event-image-div" fxLayout="row">
                                <img class="event-image" [src]="getFileNameFromUrl(event?.image)" alt="aboutpage Image" loading="lazy" width="300" height="250">
                            </div>
                        </a>
                        <hr>

                    </div>

                </div>
            </div>
        </div>


        <!-- creatics features list mobile-vew -->

        <div class="event-main-div" fxLayout="row wrap" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs
            fxHide.gt-lg>
            <div class="mob-width-class" fxLayout="column" fxLayoutGap="15px">
                <div class="mob-title">
                    {{eventMainHeading}}
                </div>
                <div class="about-div-mob event-div-mob" fxLayout="column" fxHide.lg fxHide.md fxHide.lt
                    fxFlex.lt-md fxShow.xs fxHide.gt-lg fxLayoutGap="15px">

                    <div *ngFor="let event of aboutpage?.creaticsLists"
                        [ngStyle]="event.sequence%2==0?{'background-color':'#4FC4D5'}:{'background': 'linear-gradient(#f14925 100%, #FA4616 0%)'}">

                        <a href="{{event?.url}}"
                         appTrackClick 
                        [buttonProps]="{
                        title: 'about_'+event?.title+'_button',
                        feature_context: 'ABOUT_CREATICS'
                        }"
                        >
                            <div class="event-image-div-mob" fxLayout="column">
                                <img class="event-image-mob" [src]="getFileNameFromUrl(event.image)" alt="about Image" loading="lazy">
                            </div>
                        </a>
                        <div class="event-details-div-mob" fxLayout="column wrap" fxLayoutAlign="start">
                            <p class="event-heading-mob">
                                <a href="{{event?.url}}"
                                 appTrackClick 
                                [buttonProps]="{
                                title: 'about_'+event?.title+'_button',
                                feature_context: 'ABOUT_CREATICS'
                                }"
                                >{{event.title}}</a>
                            </p>
                            <p class="event-details-mob">
                                {{event?.text}}
                            </p>
                        </div>

                    </div>

                </div>

            </div>
        </div>


        <div *ngFor="let item of aboutpage?.buttons" class="heading2 btn-div" fxLayout="row wrap" fxLayoutAlign="center">

            <a href="{{item?.buttonUrl}}"  *ngIf="!userLoggedIn">
                <button class="btn"
                 appTrackClick 
                [buttonProps]="{
                title: 'about_bottom_join_free_button',
                feature_context: 'ABOUT_CREATICS'
                }"
                >
                    {{item?.buttonName}}
                </button>
            </a>

        </div>

        <div class="heading2" fxLayout="row wrap" fxLayoutAlign="center">

            <p>{{aboutpage?.about}}</p>

        </div>

    </div>